import {DtoDetail} from "../../dto/dto.detail";


export class ObjectBrowserResultEntryDto {

    public objectAlias: string;
    public level: number;

    public objectIsNull: boolean;
    public objectId: number;
    public objectName: string;
    public createEntry: boolean;

    public parentAttributeName: string;

    public dto: DtoDetail; // optional

    public entries: ObjectBrowserResultEntryDto[];

    public requestId: number;
    public dummy: boolean;

    // UI ONLY
    public data: any
    public label: string
    public key: string
    public icon: string
    public children: ObjectBrowserResultEntryDto[];
    public expanded: boolean;

    public description: string;
    public image: string;

    /**
     * Check whether the entry is an actual object.
     * @param entry
     */
    public static isActualObject(entry: ObjectBrowserResultEntryDto) : boolean {

        if (!entry || entry.dummy || entry.createEntry) {
            // entry is null or simply a dummy or a createEntry node
            return false;
        } else if (entry.objectId && entry.objectAlias) {
            return true;
        } else {
            return false; // object ID or alias missing
        }

    }

    public static equalsStatic(entry: ObjectBrowserResultEntryDto, compare: ObjectBrowserResultEntryDto) : boolean {

        if (entry === compare) {
            return true;
        }

        if (!entry || !compare) {
            return false;
        }

        if (compare["objectAlias"] == entry["objectAlias"] &&
            compare["objectId"] == entry["objectId"] &&
            compare["dummy"] == entry["dummy"] &&
            compare["requestId"] == entry["requestId"] &&
            compare["createEntry"] == entry["createEntry"] ) {
            return true;
        } else {
            return false;
        }
    }

    public equals(entry: ObjectBrowserResultEntryDto) : boolean {
        return ObjectBrowserResultEntryDto.equalsStatic(this, entry);

    }

    public findEntry(objectType: string, objectId: number) {
        return this.findEntryInternal(this, objectType, objectId);
    }

    protected findEntryInternal(entry: ObjectBrowserResultEntryDto, objectType: string, objectId: number) : ObjectBrowserResultEntryDto {

        if (entry.objectAlias == objectType && entry.objectId == objectId) {
            return entry;
        }

        if (entry.children) {

            for (let child of entry.children) {
                let objectBrowserResultEntry = this.findEntryInternal(entry, objectType, objectId);

                if (objectBrowserResultEntry) {
                    return objectBrowserResultEntry;
                }
            }

        }

        return null;
    }

}
